import { render, staticRenderFns } from "./userRole.vue?vue&type=template&id=2b5a3a9f&scoped=true&"
import script from "./userRole.vue?vue&type=script&lang=js&"
export * from "./userRole.vue?vue&type=script&lang=js&"
import style0 from "./userRole.vue?vue&type=style&index=0&id=2b5a3a9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a3a9f",
  null
  
)

export default component.exports